export default __webpack_public_path__ + "static/media/limenaqs1.d0d1f1b7.jpeg";